export default "__VITE_ASSET__Diw648ZJ__"